const SubmitButtonGroup = (props) => {
  return (
    <div className={`cancelNextBtn ${props.GroupClassName}`}>
      {/* {!props.HideCancelBtn && <button type="button" {...props.cancelButtonclickHandler && {onClick:props.cancelButtonclickHandler}} className="btn btn-cancel">{props.SubmitBtnText?props.CancelBtnText:'Cancel'}</button>} */}
      <button
      disabled={props.isLoading}
        type="submit"
        className="btn btn-next"
        {...(props.clickHandler && { onClick: props.clickHandler })}
        {...(props.formId && { form: props.formId })}
      >
        {props.SubmitBtnText ? props.SubmitBtnText : "Next"}
      </button>
    </div>
  );
};

export default SubmitButtonGroup;
